import { Component, Inject, OnInit } from '@angular/core';
import { BaseCustomDialog } from '../base-custom-dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ACTION_DATA_SERVICE, ActionDataService } from '../../../../services/action/data.service';
import { debounce } from '../../../../helper/debounce';
import { IActionTypes } from '../../../../models/action.model';
import { ActionIconHelper } from '../../../../helper/action-icon.helper';

@Component({
  selector: 'fi-reject-request-popup',
  templateUrl: './reject-request-popup.component.html',
  styleUrls: ['./reject-request-popup.component.scss'],
  standalone: false,
})
export class RejectRequestPopupComponent extends BaseCustomDialog implements OnInit {
  contactName = '';
  leadId: number;
  selectedTypeId: number;
  rejectTypes: IActionTypes[] = [];
  suggestedTypes: IActionTypes[] = [];
  selectActive = false;
  searchedText = '';
  originalSearchedText = '';
  note = '';
  doSearch = debounce(() => this.filterData());
  showSuggestions = false;
  title: string;
  iconUrl = ActionIconHelper.getActionIconUrl('LEAD_REJECT', false);
  darkIconUrl = ActionIconHelper.getActionIconUrl('LEAD_REJECT', true);
  submitting: boolean;
  inValidNote = false;

  constructor(
    public dialogRef: MatDialogRef<RejectRequestPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { contactName: string, leadId: number, leadTypeId: number, title: string },
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService
  ) {
    super(dialogRef);

    this.contactName = dialogData?.contactName || '';
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;

    actionDataService.getRejectTypes().subscribe(({success, data}) => {
      if (success) {
        this.rejectTypes = data;
      }
    });
  }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  private filterData(): void {
    const value = this.searchedText;

    if (!value) {
      this.showSuggestions = false;
      setTimeout(_ => {
        this.suggestedTypes = this.rejectTypes;
      }, 300);
      return;
    }

    const searchedValue = value.split(' ').filter(item => item !== '');
    this.suggestedTypes = this.getFilters(searchedValue, [...this.suggestedTypes]);
  }

  private getFilters(searchedValue: string[], allItems: IActionTypes[]): IActionTypes[] {
    const result: IActionTypes[] = [];
    searchedValue.forEach(item => {
      const arr = allItems.filter((elem, index) => {
        const expression = new RegExp(`^${item}| ${item}`, 'gmi');
        const match = expression.test(elem.Name);
        if (match) {
          allItems.splice(index, 1);
        }
        return match;
      });

      result.push(...arr);
    });

    return result;
  }

  toggleSelect($event: Event): void {
    $event.stopPropagation();
    this.selectActive = !this.selectActive;

    if (this.selectActive) {
      this.suggestedTypes = this.rejectTypes;
    }
  }

  showSelect($event: Event): void {
    $event.stopPropagation();
    this.selectActive = true;
    this.suggestedTypes = this.rejectTypes;
  }

  hideSelect(): void {
    this.selectActive = false;
  }

  selectResultItem($event: string): void {
    this.selectedTypeId = +$event;
  }

  get formIsValid(): boolean {
    return !!this.leadId && !!this.selectedTypeId && this.originalSearchedText === this.searchedText && !this.submitting && !this.inValidNote;
  }

  inValidMaxLength(): boolean {
    this.inValidNote = this.note.length > 2000;
    return this.inValidNote;
  }

  submit(): void {
    if (this.formIsValid) {
      this.submitting = true;
      this.actionDataService.rejectRequest(this.leadId, this.note, this.selectedTypeId).subscribe(({success, data}) => {
        if (success) {
          this.clearClassAndCloseDialog(this.dialogRef, 'remove');
        }

        this.submitting = false;
      });
    }
  }
}
